import {
  Card,
  CardContent,
  Grid,
  Paper,
  Typography
} from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ResponsiveAppBar from "../ResponsiveAppBar";
import { useAdminStatsQuery, useGetUserInfoQuery } from "../services/api";
import { StyledHeaderBox } from "../StyledHeaderBox";
import { AdminStats } from "../types";

const Admin = () => {
  const { data: user } = useGetUserInfoQuery();
  const navigate = useNavigate();
  useEffect(() => {
    if (user?.role !== 'admin')
      navigate('/dashboard')
  }, [navigate, user])

  if (!user || user.role !== 'admin')
    return null;

  return (
    <AdminInternal />
  )
}

const AdminInternal = () => {
  const { data: stats } = useAdminStatsQuery();
  if (!stats)
    return null;

  return (
    <>
      <ResponsiveAppBar />
      <Paper
        style={{
          background: '#a0b1af',
          height: 'calc(100vh - 56px)',
          overflow: 'scroll',
          paddingBottom: 10,
          paddingTop: 10,
        }}
      >
        <StyledHeaderBox>
          <Typography
            sx={{
              marginLeft: { xs: 1 }
            }}
            variant="h6"
          >Admin</Typography>
        </StyledHeaderBox>
        <Card
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: 10,
          }}
        >
          <CardContent
            style={{
              flex: 1,
            }}
          >
            <Grid container>
              {Object.keys(stats).map(key => (
                <>
                  <Grid item xs={3}>
                    <Typography
                      style={{
                        fontWeight: 500,
                      }}
                    >{key}:</Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>{stats[key as keyof AdminStats]}</Typography>
                  </Grid>
                </>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Paper>
    </>
  )
}

export default Admin;